













































import {Component, Prop, Provide, Vue} from 'vue-property-decorator'
import {InputExportarRelatorioFaturamentoSchema} from '@/schema/resource/RelatorioGeracao/InputExportarRelatorioFaturamentoSchema'
import {Helper} from 'simpli-web-sdk'
import {ExportarRelatorioFaturamento} from '@/model/resource/ExportarRelatorioFaturamento'
import moment from 'moment'

@Component
export default class ModalExportReport extends Vue {
  model = new ExportarRelatorioFaturamento()
  schema = new InputExportarRelatorioFaturamentoSchema()

  openEvent(faturamento?: ExportarRelatorioFaturamento) {
    this.$emit('open')

    if (faturamento) {
      this.model.ehGrupoEconomico = faturamento.ehGrupoEconomico
      this.model.responsavel = faturamento.responsavel
    } else {
      this.close()
    }
  }

  closeEvent() {
    this.model.reset()
    this.$emit('close')
  }

  validate(date: string | null) {
    const d = moment(date ?? '', this.$t('system.format.inputDate') as string)
    return moment(d).isValid()
  }

  async confirmEvent() {
    if (this.model.responsavel == null) {
      Helper.abort('system.error.responsavelNulo')
    }
    if (!this.validate(this.model.dataInicial)) {
      Helper.abort('system.error.invalidDataInicial')
    }
    if (!this.validate(this.model.dataFinal)) {
      Helper.abort('system.error.invalidDataFinal')
    }

    await this.model.exportReport()
    await Helper.success('system.success.persist')
    this.close()
  }

  async cancelEvent() {
    this.$emit('cancel')
    this.close()
  }

  close() {
    this.$modal.close('exportReport')
  }
}
